// 充值统计截止后仍可兑换，直到活动页面关闭。
export const getActivityPhase = (now, start, end) => {
  if (!now || !start || !end || end <= start) return 'loading'
  if (now < start) return 'not-start'
  if (now >= end) return 'ended'
  return 'active'
}

export const remainingQuantity = (goods, status = {}) => {
  const total = Number(goods.purchaseLimit) || 0
  const daily = Number(goods.dailyLimit) || 0
  return Math.max(0, Math.min(
    total > 0 ? total - (Number(status.purchasedCount) || 0) : Infinity,
    daily > 0 ? daily - (Number(status.todayCount) || 0) : Infinity
  ))
}

export const maxPurchaseQuantity = (goods, status, balance) => {
  const price = Number(goods.price)
  if (!Number.isFinite(price) || price <= 0) return 0
  return Math.max(0, Math.min(remainingQuantity(goods, status), Math.floor((Number(balance) || 0) / price)))
}
